import React from 'react';
import logo from '../../assets/footer_logo.png';
import './Footer.scss';
import { FaFacebookF, FaInstagram, FaTwitter} from "react-icons/fa";
import { Link } from 'react-router-dom';
import call from '../../assets/footer/calling.png';
import time from '../../assets/footer/time.png';
import location from '../../assets/footer/location.png';

const Footer = () => {

    const footerMenu = [
        {
            'name' : 'Hakkımızda',
            'link' : '/hakkimizda'
        },
        {
            'name' : 'Hizmetler',
            'link' : '/kanal-tedavisi'
        },
        {
            'name' : 'Doktorlarımız',
            'link' : '/hakkimizda'
        },
        {
            'name' : 'Bloglar',
            'link' : '/bloglar'
        },
        {
            'name' : 'SSS',
            'link' : '/hakkimizda'
        }
    ];

    const footerContacts = [
        {
            'title': 'Telefon Numarası',
            'info': '+088 123 654 987',
            'icon': call
        },
        {
            'title': 'Çalışma Saatleri',
            'info': '09:00 - 18:00',
            'icon': time
        },
        {
            'title': 'Klinik Adresi',
            'info': '35 West Dental Street, California 1004',
            'icon': location
        }
    ]

    return (
        <footer className='pt-100 pb-70'>
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-5">
                        <div className="footer-logo">
                            <img src={logo} alt="logo" />
                        </div>
                        <p>Dentalist, estetik, koruyucu ve restoratif diş hekimliği alanlarında güvenilir ve modern çözümler sunan bir ağız ve diş sağlığı kliniğidir.</p>

                        <div className="social-logo">
                            <p>Bizi takip edin</p>
                            <ul>
                                <li><a href="/"><FaFacebookF/></a></li>
                                <li><a href="/"><FaTwitter/></a></li>
                                <li><a href="/"><FaInstagram/></a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-2 col-md-2">
                        <div className="footer-link">
                            <p>Hızlı Linkler</p>
                            <ul>
                                {
                                    footerMenu.map(singleMenu => <li key={singleMenu.name}><Link to={singleMenu.link}>{singleMenu.name}</Link></li>)
                                }
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-5">
                        <div className="footer-contact">
                            <p>İletişim ve Bilgi</p>

                            {
                                footerContacts.map(footerContact => {
                                    return  <div className="contact-list" key={footerContact.title}>
                                                <div className="contact-icon">
                                                    <img src={footerContact.icon} alt="call" />
                                                </div>
                                                <div className="contact-text">
                                                    <p>{footerContact.title}</p>
                                                    <h5>{footerContact.info}</h5>
                                                </div>
                                            </div>
                                })
                            }
                        </div>
                    </div>
                </div>

                <div className="copyright-area">
                    <div className='copy-text'>
                        <p>&copy; Dentalist. Tüm hakları saklıdır.</p>
                    </div>  
                    <div className='copy-links'>
                        <ul>
                            <li><Link to='/hakkimizda'>Kullanım Koşulları</Link></li>
                            <li><Link to='/hakkimizda'>Gizlilik Politikası</Link></li>
                        </ul>
                    </div>                          
                </div>
            </div>
        </footer>
    );
};

export default Footer;